import { GameRandom, Inject, SimpleBaseController, } from "../../../../modules/@denishussar/html5-game-engine";
import { GameModel } from "../../../Models/GameModel";
import { GameLogic } from "../../../Logic/GameLogic";
import { SpineAnimationBaseController } from "../../Spine/SpineAnimationBaseController";
import { PlayerJumpingStateConstants } from "../../../Constants/PlayerJumpingStateConstants";

export interface IDBPlayerControllerOptions {
    gender: string;
}

export class DBPlayerController extends SimpleBaseController {
    $model: GameModel;

    private _spineAnimationController: SpineAnimationBaseController;

    private _current: string = "";
    private _jumpTime = 0.4;

    public constructor(@Inject private _options: IDBPlayerControllerOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic) {
        super("DBPlayerController");
    }

    protected getConfiguration() {
        const outfitView = this.$model.outfitView + 1;

        return {
            childControllers: {
                animation: {
                    controller: SpineAnimationBaseController,
                    model: this.$model,
                    options: {
                        key: 'char_x2_json',
                        url: '/images/spine/char_x2/char_x2.json',
                        animations: [
                            'idle_man',
                            'idle_woman',
                            'jump_man',
                            'jump_woman',
                            'lose_man',
                            'lose_woman',
                            'run_man',
                            'run_woman'
                        ]
                    }
                }
            },
            modelWatch: {
                "player.isRun": (isRun: boolean) => {
                    if (isRun) {
                        this.run();
                    } else {
                        this.idle();
                    }
                },
                "player.jumpingState": (jumpingState: PlayerJumpingStateConstants) => {
                    if (jumpingState === PlayerJumpingStateConstants.One) {
                        this.jump();
                    } /* else if (jumpingState === PlayerJumpingStateConstants.Two){
                        this.doubleJump();
                    } */
                },
                "player.pos.y": (y: number) => {
                    if (y === 0 && this._current !== 'run' && this.$model.player.isRun) {
                        this.run();
                    }
                },
                "player.isFall": (isFall: boolean) => {
                    if (isFall) {
                        this.lose();
                    }
                },
                "startNewGame": (startNewGame: boolean) => {
                    if (startNewGame) {
                        this.idle();
                    }
                },

                "pause": (pause: boolean) => {
                    if (pause) {
                        if (!this.$model.player.isFall) {
                            this.idle();
                        }

                    } else if (this.$model.player.isRun) {
                        this.run();
                    } else if (!this.$model.player.isFall) {
                        //this.idle();
                    }
                }

            },
            queue: {
                playerJumpEnd: {
                    condition: (time: number) => {
                        return time > 0.5
                    },
                    action: () => {
                        if (this.$model.player.isRun && !this.$model.pause) {
                            //this.run();
                        }
                    }
                },
            }
        };
    }

    protected onInitialize(): void {
        this._spineAnimationController = this.$childControllers.get('animation');
        this.idle();
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

    run() {
        this._play('run', -1);
    }

    idle() {
        this._play('idle', -1);
    }

    jump() {
        this._play("jump", 1);
        this.$queue.get('playerJumpEnd').addToQueue(1);
    }

    lose() {
        this._play("lose", 1);
    }

    private _play(name, amount: number) {
        this._spineAnimationController.setAnimation(`${name}_${this._options.gender}`, amount === -1);
    }
}

